import BaseService from '@core/class/BaseService';
import {
  IExportQueryParams,
  IPagination,
  IQueryParams
} from '../../Product/interfaces';
class ShippingServices extends BaseService {
  public fetchData = ({
    productName,
    page,
    fieldSearch,
    sort,
    fromDt,
    toDt
  }: IPagination) => {
    let data = [...Array(10)].map((item, index) => ({
      ...item,
      ...{
        productName: ['', 't-Shirt', 'Jean', 'Kaky', 'Hat'][
          Math.ceil(Math.random() * 3)
        ],
        quantity: [1, 1, 3, 5, 6, 8][Math.ceil(Math.random() * 5)],
        SSKU: 33012 + Number(index),
        centerName: ['', 'Old', 'New'][Math.ceil(Math.random() * 2)],
        UpdateDate:
          new Date().getTime() +
          [0, 1000, 10000, 3000][Math.ceil(Math.random() * 3)]
      }
    }));
    return { data: data };
  };

  public getPaging = ({
    productName,
    page,
    fieldSearch,
    sort,
    fromDt,
    toDt
  }: IPagination) => {
    let url = 'api/v1/seller/orders' + `?page=${page}&limit=10`;
    url =
      productName !== '' &&
      productName !== null &&
      fieldSearch !== '' &&
      !!fieldSearch
        ? (url += `&filter.${fieldSearch}=${productName}`)
        : url;
    url = sort
      ? (url += `&sortBy=updated_at:DESC`)
      : (url += '&sortBy=updated_at:ASC');
    url = fromDt ? (url += `&filter.from=${fromDt}`) : url;
    url = toDt ? (url += `&filter.to=${toDt}`) : url;
    return this.get(url);
  };

  public getDetailShipping = (shippingId: number | string) => {
    return this.get(`api/v1/seller/orders/detail/${shippingId}`);
  };

  public getProduct = (warehouseId: number, productName: string) => {
    return this.get(
      `api/v1/seller/products/list-create-request?warehouseId=${warehouseId}&productName=${productName}`
    );
  };

  public getWarehouse = (WarehouseName: string) => {
    return this.get(
      `api/v1/seller/warehouses/warehouse-imported/list-create-request?name=${WarehouseName}`
    );
  };

  public exportExcelById = (productId: number[]) => {
    let value = 'ids=';
    productId.forEach((item: number) => {
      value = value + item + ',';
    });
    return this.get(
      `api/v1/seller/orders/export?${value.substring(0, value.length - 1)}`,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public exportExcel = ({
    fieldSearch,
    productName,
    sort,
    fromDt,
    toDt
  }: IPagination) => {
    let url = `api/v1/seller/orders/export-all?`;
    url +=
      (!!productName && !!fieldSearch
        ? `&filter.${productName}=${fieldSearch}`
        : '') +
      (!!fromDt ? `&filter.from=${fromDt}` : '') +
      (!!toDt ? `&filter.from=${fromDt}` : '') +
      (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC`);
    let urlUse = url.replace('?&', '?');
    return this.get(
      urlUse,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public putUpdateShipping = (
    body: Record<string, any>,
    shippingId: number
  ) => {
    return this.put(`api/v1/seller/orders/${shippingId}`, body);
  };

  public postCreateShipping = (body: Record<string, any>) => {
    return this.post('api/v1/seller/orders', body);
  };

  public postUpdateShipping = (id: number, body: Record<string, any>) => {
    return this.put(`api/v1/seller/orders/${id}`, body);
  };

  public removeShipping = (id: number) => {
    return this.delete(`api/v1/seller/orders/${id}`);
  };

  public createShippingCSV = (form: FormData) => {
    return this.post('api/v1/seller/orders/csv', form);
  };

  public getTemplateShippingCSV = () => {
    return this.get(
      'api/v1/seller/orders/csv',
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public postCreateShippingAmazon = (body: Record<string, any>) => {
    return this.post('api/v1/seller/orders/amazon-order', body);
  };

  public getAmazonOrder = (orderName: string) => {
    return this.get(
      `api/v1/seller/orders/amazon-order?orderNumber=${orderName ?? ''}`
    );
  };

  public getAmazonOrderDetail = (id: string) => {
    return this.get(`api/v1/seller/orders/amazon-order/detail/${id ?? ''}`);
  };

  public downloadInvoice = ({orderId, orderNumber, warehouseId} : {
    orderId: number,
    orderNumber: string,
    warehouseId: number
  }) => {
    return this.get(`api/v1/seller/orders/detail/${orderId}/download-invoice?orderNumber=${orderNumber}&warehouseId=${warehouseId}`, {}, {
      'Content-Type': 'application/pdf',
      'responseType': 'blob'
    });
  }
}

export default new ShippingServices('/', true);
